export type PhotoRequest = {
  serviceURL: string;
  publicKey: string;
  accessToken?: string;
  evidenceId: string;
  signal?: AbortSignal;
};

/** Fetch bytes through the authorization-checking endpoint, never a bearer URL. */
export async function fetchEvidencePhoto(
  request: PhotoRequest,
  fetcher: typeof fetch = fetch,
): Promise<Blob> {
  const response = await fetcher(
    `${request.serviceURL.replace(/\/$/, "")}/functions/v1/evidence-photo`,
    {
      method: "POST",
      headers: {
        apikey: request.publicKey,
        ...(request.accessToken
          ? { Authorization: `Bearer ${request.accessToken}` }
          : {}),
        "Content-Type": "application/json",
        Accept: "image/jpeg",
      },
      body: JSON.stringify({ evidence_id: request.evidenceId }),
      signal: request.signal,
      cache: "no-store",
      redirect: "error",
      credentials: "omit",
    },
  );
  if (!response.ok) {
    if ([401, 403, 404].includes(response.status))
      throw new Error(
        "This photo is no longer available to your account. Refresh the sighting to check its status.",
      );
    throw new Error("The shelf photo could not be loaded. Please try again.");
  }
  if (
    response.headers.get("Content-Type")?.split(";")[0].trim().toLowerCase() !==
    "image/jpeg"
  )
    throw new Error("The shelf photo service returned an unexpected response.");
  const photo = await response.blob();
  if (!photo.size) throw new Error("This shelf photo is empty.");
  return photo;
}
